import { CheckOutlined, MinusOutlined } from '@ant-design/icons'
import React from 'react'
import styled from 'styled-components'
import { PasswordValidationResult } from '../../utils/cognito'

const PasswordValidationList = styled.ul`
  list-style-type: none;
  padding: 0;
  padding-left: 12px;
`

const StyledCheck = styled(CheckOutlined)`
  color: ${({ theme }) => theme.colors.darkMint};
`

const StyledMinus = styled(MinusOutlined)`
  color: ${({ theme }) => theme.greys.chateau};
`

const ValidationItem: React.FC<{ ok: boolean }> = (props) => (
  <li>
    {props.ok ? <StyledCheck /> : <StyledMinus />} {props.children}
  </li>
)

interface Props {
  passwordValidations: PasswordValidationResult
}

export const PasswordFeedback = (props: Props): JSX.Element => (
  <PasswordValidationList>
    <ValidationItem ok={props.passwordValidations.minLength}>
      12 character minimum
    </ValidationItem>
    <ValidationItem ok={props.passwordValidations.upperCase}>
      1 uppercase letter
    </ValidationItem>
    <ValidationItem ok={props.passwordValidations.lowerCase}>
      1 lowercase letter
    </ValidationItem>
    <ValidationItem ok={props.passwordValidations.specialChar}>
      1 special character
    </ValidationItem>
    <ValidationItem ok={props.passwordValidations.digit}>
      1 number
    </ValidationItem>
  </PasswordValidationList>
)
